import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteSessionService } from '@app/store/session/session.service';

@Component({
	selector: 'qe-zip-search-modal',
	templateUrl: './zip-search-modal.component.html',
	styleUrls: ['./zip-search-modal.component.scss'],
})
export class ZipSearchModalComponent {

	public vetClinicZip: FormControl;

	constructor(
		  private readonly dialogRef: MatDialogRef<ZipSearchModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: string,
		private readonly sessionService: QuoteSessionService,
	) {
		this.vetClinicZip = new FormControl(
			this.data,
			[
				/* eslint-disable @typescript-eslint/no-magic-numbers */
				Validators.required,
				Validators.minLength(5),
				Validators.maxLength(5),
				Validators.pattern(/^[\d]*$/),
				/* eslint-enable */
			],
		);
	}

	public updateZipCode(): void {
		if (this.vetClinicZip.invalid) return;
		this.sessionService.updateVetSearchZip(this.vetClinicZip.value);
		this.dialogRef.close();
	}

}
